'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterBootstrap = require('react-router-bootstrap');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var uniqueId = function uniqueId() {
  return Math.random();
};

var BinaryBreadCrum = function (_Component) {
  _inherits(BinaryBreadCrum, _Component);

  function BinaryBreadCrum(props) {
    _classCallCheck(this, BinaryBreadCrum);

    var _this = _possibleConstructorReturn(this, (BinaryBreadCrum.__proto__ || Object.getPrototypeOf(BinaryBreadCrum)).call(this, props));

    _this.styles = require('./BinaryBreadCrum.scss');
    return _this;
  }

  _createClass(BinaryBreadCrum, [{
    key: 'getBreadCrums',
    value: function getBreadCrums() {
      var _this2 = this;

      var _props = this.props,
          hierarchy = _props.hierarchy,
          handleBreadCrumClick = _props.handleBreadCrumClick;

      var breadcrums = [];
      var count = 1;
      hierarchy.forEach(function (item) {
        if (item) {
          var currHierarchy = hierarchy.slice(0, count);
          var className = _this2.styles.binary_breadcrum_item;
          var icon = _react2.default.createElement('i', { className: 'icon-Right' });
          var style = _this2.props.style ? _this2.props.style : {};
          if (count === hierarchy.length) {
            icon = _react2.default.createElement('i', { style: { 'display': 'none' }, className: 'icon-Right' });
            className = _this2.styles.binary_breadcrum_item_last;
          }
          if (!handleBreadCrumClick) {
            style.cursor = 'auto';
          }
          if (item.href && item.href !== null) {
            breadcrums.push(_react2.default.createElement(
              _reactRouterBootstrap.LinkContainer,
              { key: uniqueId(), to: item.href, onClick: item.reload && _this2.handleReload.bind(_this2) },
              _react2.default.createElement(
                'span',
                {
                  className: className,
                  id: item.name.toLowerCase().split(' ').join('_'),
                  onClick: _this2.handleBreadCrumClick.bind(_this2, currHierarchy)
                },
                item.name,
                ' ',
                icon
              )
            ));
          } else {
            // style.color = '#000';
            breadcrums.push(_react2.default.createElement(
              'span',
              {
                className: className,
                key: uniqueId(),
                style: style,
                id: item.name ? item.name.toLowerCase().split(' ').join('_') : '',
                onClick: _this2.handleBreadCrumClick.bind(_this2, currHierarchy)
              },
              item.name,
              ' ',
              icon
            ));
          }
        }
        count++;
      });
      return breadcrums;
    }
  }, {
    key: 'handleReload',
    value: function handleReload() {
      setTimeout(function () {
        window.location.reload();
      }, 2000);
    }
  }, {
    key: 'handleBreadCrumClick',
    value: function handleBreadCrumClick(hierarchy) {
      var handleBreadCrumClick = this.props.handleBreadCrumClick;

      if (handleBreadCrumClick) {
        handleBreadCrumClick(hierarchy);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var breadcrums = this.getBreadCrums();
      return _react2.default.createElement(
        'p',
        { className: this.styles.binary_breadcrum_container },
        breadcrums.length > 1 && breadcrums
      );
    }
  }]);

  return BinaryBreadCrum;
}(_react.Component);

BinaryBreadCrum.propTypes = {
  style: _propTypes2.default.object,
  hierarchy: _propTypes2.default.array.isRequired,
  handleBreadCrumClick: _propTypes2.default.func
};
exports.default = BinaryBreadCrum;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinaryBreadCrum/BinaryBreadCrum.js
// module id = 491
// module chunks = 1